import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import PaymentForm from './PaymentForm'
import Contact from './Contact'
import AboutImages from './AboutImages'
import InstagramComments from './InstagramComments'
import { SupabaseFunctionsService } from '../services/supabaseFunctionsService'

const RetreatLanding = () => {
  // const navigate = useNavigate()
  const heroRef = useRef(null)
  const featuresRef = useRef(null)
  const scheduleRef = useRef(null)
  const [showPayment, setShowPayment] = useState(false)
  const [openFAQ, setOpenFAQ] = useState(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active')
          }
        })
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    )

    const elements = [heroRef.current, featuresRef.current, scheduleRef.current].filter(Boolean)
    elements.forEach(element => observer.observe(element))

    return () => {
      elements.forEach(element => observer.unobserve(element))
    }
  }, [])

  const [retreatData, setRetreatData] = useState({
    // id: 1,
    // title: "Sacred Healing Retreat",
    // subtitle: "A Transformative Journey into Deep Healing and Consciousness Expansion",
    // date: "October 17, 2025",
    // location: "Joshua Tree, California",
    // duration: "3 Days / 2 Nights",
    // price: 998,
    // description: "Experience plant medicine ceremonies, trauma release work, and integration practices in the sacred energy of Joshua Tree. This retreat is designed for those seeking deep healing, spiritual growth, and connection with their authentic self.",
    // features: [
    //   "Plant medicine ceremony with experienced facilitators",
    //   "Trauma release and somatic healing sessions",
    //   "Daily meditation and breathwork practices",
    //   "Integration circles and group sharing",
    //   "Sacred site visits and nature connection",
    //   "Organic, nourishing meals included",
    //   "Comfortable accommodation in nature"
    // ],
    // schedule: [
    //   {
    //     day: "Day 1 - Arrival & Opening",
    //     activities: [
    //       "3:00 PM - Arrival and check-in",
    //       "4:00 PM - Welcome circle and introductions",
    //       "5:30 PM - Opening ceremony and intention setting",
    //       "7:00 PM - Dinner and group bonding",
    //       "8:30 PM - Evening meditation and preparation"
    //     ]
    //   },
    //   {
    //     day: "Day 2 - Deep Healing",
    //     activities: [
    //       "7:00 AM - Morning meditation and breathwork",
    //       "8:00 AM - Breakfast",
    //       "9:30 AM - Plant medicine ceremony",
    //       "12:00 PM - Integration and processing",
    //       "1:00 PM - Lunch and rest",
    //       "3:00 PM - Trauma release and somatic healing",
    //       "5:00 PM - Nature walk and grounding",
    //       "7:00 PM - Dinner",
    //       "8:30 PM - Integration circle and sharing"
    //     ]
    //   },
    //   {
    //     day: "Day 3 - Integration & Departure",
    //     activities: [
    //       "7:00 AM - Morning meditation and reflection",
    //       "8:00 AM - Breakfast",
    //       "9:30 AM - Integration workshop and tools",
    //       "11:00 AM - Closing ceremony and gratitude",
    //       "12:00 PM - Lunch and final sharing",
    //       "2:00 PM - Check-out and departure"
    //     ]
    //   }
    // ],
    // spotsLeft: 8,
    // maxSpots: 12,
    // image: "fas fa-mountain"
  })

  // Load retreat data from Supabase
  useEffect(() => {
    const loadRetreatData = async () => {
      try {
        const result = await SupabaseFunctionsService.getAllRetreats()
        if (result.success) {
          const retreat = result.retreats[0]
          setRetreatData({
            id: retreat.id,
            title: retreat.title,
            subtitle: retreat.subtitle,
            date: retreat.date,
            location: retreat.location,
            duration: retreat.duration,
            price: parseFloat(retreat.price),
            description: retreat.description,
            features: retreat.features || [],
            schedule: retreat.schedule || [],
            spotsLeft: retreat.spotsLeft,
            maxSpots: retreat.maxSpots,
            image: "fas fa-mountain"
          })
        }
      } catch (error) {
        console.error('Failed to load retreat data:', error)
        // Keep default data if Supabase fails
      }
    }

    loadRetreatData()
  }, [])

  const handleBookRetreat = () => {
    setShowPayment(true)
  }

  const handlePaymentSuccess = (paymentIntent, registrationData, registration) => {
    setShowPayment(false)
    
    // Update spots left in local state
    setRetreatData(prev => ({
      ...prev,
      spotsLeft: prev.spotsLeft - 1
    }))
    
    console.log('Registration Data:', registrationData)
    console.log('Payment Intent:', paymentIntent)
    console.log('Registration:', registration)
    
    alert(`Registration and payment successful! You will receive a confirmation email for the ${retreatData.title} with all the details.`)
  }

  const handlePaymentCancel = () => {
    setShowPayment(false)
  }

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index)
  }

  return (
    <div className="retreat-landing">
      {/* Hero Section */}
      <section className="retreat-hero" ref={heroRef}>
        <div className="hero-background">
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            {/* <div className="hero-badge">
              <span className="spots-left">{retreatData.spotsLeft} spots remaining</span>
            </div> */}
            <h1 className="hero-title">{retreatData.title}</h1>
            <p className="hero-subtitle">{retreatData.subtitle}</p>
            {/* <p className="hero-description">{retreatData.description}</p> */}
            <p className="hero-description">
              Medicine isn’t Netflix for the soul. <br />
              Dragons, snakes, and sacred geometry won’t do the work for you. <br />
              Here, we face what’s buried, feel it through, and set ourselves free.
            </p>
            
            <div className="hero-details">
              <div className="detail-item">
                <i className="fas fa-calendar-alt"></i>
                <span>{retreatData.date}</span>
              </div>
              <div className="detail-item">
                <i className="fas fa-map-marker-alt"></i>
                <span>{retreatData.location}</span>
              </div>
              <div className="detail-item">
                <i className="fas fa-clock"></i>
                <span>{retreatData.duration}</span>
              </div>
            </div>

            <div className="hero-price">
              <span className="price">${retreatData.price}</span>
              <span className="price-note">per person</span>
            </div>

            <div className="hero-actions">
              <button 
                className="btn btn-primary btn-large book-now-btn"
                onClick={handleBookRetreat}
              >
                <i className="fas fa-calendar-plus"></i>
                Book
              </button>
              {/* <button 
                className="btn btn-secondary btn-large"
                onClick={() => navigate('/')}
              >
                <i className="fas fa-arrow-left"></i>
                Back to Home
              </button> */}
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="retreat-philosophy">
        <div className="container">
          <div className="philosophy-content">
            <p className="philosophy-title">
              Psychology meets Spirituality.
            </p>

            <div className="philosophy-main">
              <p className="main-statement">
                This is your appt w/ freedom from human suffering.
              </p>
              
              <p className="philosophy-description">
                Through guided, trauma-informed workshops, we map consciousness and bring the unconscious to light — so we stop calling it fate. 
                Your attention is the most expensive currency you hold. Learn to direct it, hold complex human emotions, 
                see truth beyond conditioning, and stay grounded even in your vulnerability.
              </p>
              
              <p className="philosophy-commitment">
                We will do real psychological heavy lifting, process what's been suppressed for years.
              </p>
            </div>

            <div className="philosophy-questions">
              <p className="question">Which patterns, habits, or stories are you ready to let go for good?</p>
              <p className="question">Where do you notice resistance? Which fears are ready to be faced and released?</p>
            </div>

            <div className="philosophy-transformation">
              <p className="transformation-call">No more running.</p>
              <p className="transformation-call">Full stop.</p>
              <p className="transformation-call">Into what IS.</p>
              <p className="transformation-process">Feel. Breathe. Cry. Scream. Be Human.</p>
              <p className="transformation-result">Then rewire old wounds into pathways of power, truth, and your gift to humanity.</p>
            </div>

            <div className="philosophy-vision">
              <p className="vision-text">
                From here, you'll begin to build the vision of the self you were always meant to live — 
                the one forgotten under the weight of conditioning and survival.
              </p>
              <p className="vision-question">Do you know how they look like? <br />
                Are you ready to meet them?</p>
            </div>

            <div className="philosophy-community">
              <p className="community-call">
                Join a safe, supportive community ready to meet life raw and unfiltered, 
                with grace and self-compassion.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="retreat-about">
        <div className="container">
          <div className="about-content">
            <h2>About The Facilitator</h2>
            <div className="facilitator-info">
              <a href="https://victoriasaldina.com" target="_blank" rel="noopener noreferrer" className="facilitator-link">
                <img 
                  src="/VictoriaS.jpg" 
                  alt="Victoria Saldina" 
                  className="facilitator-image"
                />
              </a>
              <p className="about-description">
                <a href="https://victoriasaldina.com" target="_blank" rel="noopener noreferrer">
                  Victoria Saldina
                </a>
                &nbsp; is a guide and consciousness architect devoted to helping others liberate themselves from human suffering and destructive conditioning.
                <br />
                Her path led through an upbringing in an abusive, alcoholic household in Russia, followed by a full death experience in her early 30s, and a return to life with only a 6% chance of coming out of a coma.
              </p>
              <p className="about-description">
                That moment changed everything — how she sees life, the complexity and beauty of the human experience, and purpose itself. Her work fuses psychology and spirituality, helping you map your inner world, reclaim your sharp presence, and meet life in its raw, unfiltered truth.
              </p>
              <p className="about-description">
                Victoria creates spaces where the unconscious becomes conscious, and being human can feel safe, liberating, alive, and deeply meaningful. 
              </p>
            </div>
            
            {/* <div className="about-highlights">
              <div className="highlight-item">
                <i className="fas fa-heart"></i>
                <h3>Deep Healing</h3>
                <p>Experience profound emotional and spiritual healing through plant medicine and therapeutic practices.</p>
              </div>
              <div className="highlight-item">
                <i className="fas fa-users"></i>
                <h3>Small Group</h3>
                <p>Intimate setting with maximum 12 participants ensures personalized support and guidance.</p>
              </div>
              <div className="highlight-item">
                <i className="fas fa-leaf"></i>
                <h3>Sacred Nature</h3>
                <p>Connect with the healing power of Joshua Tree's unique desert landscape and energy.</p>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* About Images Section */}
      <AboutImages />

      {/* Instagram Comments Section */}
      <InstagramComments />

      {/* Features Section */}
      {/* <section className="retreat-features" ref={featuresRef}>
        <div className="container">
          <h2>What's Included</h2>
          <div className="features-grid">
            {retreatData.features?.map((feature, index) => (
              <div key={index} className="feature-item">
                <i className="fas fa-check"></i>
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Schedule Section */}
      <section className="retreat-schedule" ref={scheduleRef}>
        <div className="container">
          <h2>Retreat Schedule</h2>
          <div className="schedule-timeline">
            {retreatData.schedule?.map((day, index) => (
              <div key={index} className="schedule-day">
                <div className="day-header">
                  <h3>{day.day}</h3>
                </div>
                <div className="day-activities">
                  {day.activities.map((activity, activityIndex) => (
                    <div key={activityIndex} className="activity-item">
                      <span className="activity-time">{activity.split(' - ')[0]}</span>
                      <span className="activity-description">{activity.split(' - ')[1]}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="retreat-faq">
        <div className="container">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-content">
            {[
              {
                icon: "💰",
                question: "Do you offer financial support?",
                answer: (
                  <p>
                    We understand that financial constraints shouldn't prevent someone from accessing healing and transformation. 
                    We offer limited financial assistance and payment plans for those who demonstrate genuine need. 
                    Please <a href="#contact" className="faq-link">contact us directly</a> to discuss your situation and explore available options.
                  </p>
                )
              },
              {
                icon: "🛏",
                question: "What are the lodging arrangements?",
                answer: (
                  <>
                    <p>
                      Our retreat offers a welcoming shared space with comfortable queen-size bunk beds in a cozy common room.
                      For those seeking more privacy, we also have 2 private rooms available upon request for an additional cost.
                    </p>
                    <p>
                      If you prefer more privacy and comfort, you're free to book an Airbnb nearby 
                      (exact location details will be sent by email after registration).
                    </p>
                  </>
                )
              },
              {
                icon: "🍲",
                question: "What food and nourishment is provided?",
                answer: (
                  <p>
                    Fresh soup, fruits, and light snacks will be provided during the retreat. 
                    You're welcome to bring your own food as well — ideally brain-friendly and filling options. 
                    Please avoid heavy meats.
                  </p>
                )
              },
              {
                icon: "📋",
                question: "What should I bring?",
                answer: (
                  <p>
                    Bring comfortable clothing for meditation and movement, a journal for reflection, 
                    any personal items you need for comfort, and an open heart ready for transformation. 
                    You may also bring your own food if you have specific dietary needs.
                  </p>
                )
              },
              {
                icon: "❓",
                question: "What if I'm new to this type of work?",
                answer: (
                  <p>
                    This retreat is designed for people at all levels of experience. Whether you're new to consciousness work 
                    or have been on this path for years, Victoria's approach meets you where you are. 
                    The focus is on creating a safe space for authentic human experience and growth.
                  </p>
                )
              }
            ].map((faq, index) => (
              <div key={index} className={`faq-item ${openFAQ === index ? 'active' : ''}`}>
                <div className="faq-question" onClick={() => toggleFAQ(index)}>
                  <h3>
                    <span className="icon">{faq.icon}</span>
                    {faq.question}
                  </h3>
                  <i className={`fas fa-chevron-down faq-toggle ${openFAQ === index ? 'rotated' : ''}`}></i>
                </div>
                <div className="faq-answer">
                  {faq.answer}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="retreat-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to upgrade your consciousness?</h2>
            <p>Book your appt w/ freedom from human suffering.</p>
            <div className="cta-actions">
              <button 
                className="btn btn-primary btn-large book-now-btn"
                onClick={handleBookRetreat}
              >
                <i className="fas fa-calendar-plus"></i>
                Book
              </button>
              {/* <div className="urgency-message">
                <i className="fas fa-exclamation-triangle"></i>
                Only {retreatData.spotsLeft} spots left!
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <Contact />

      {/* Footer */}
      <footer className="retreat-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-links">
              <a href="/terms" className="footer-link">
                Terms & Conditions
              </a>
            </div>
            <div className="footer-text">
              <p>&copy; {new Date().getFullYear()} Consciousness Upgrade 2.0. All rights reserved.</p>
            </div>
          </div>
        </div>
      </footer>

      {/* Payment Modal */}
      {showPayment && (
        <div className="payment-modal">
          <div className="payment-modal-content">
            <PaymentForm
              service={retreatData}
              amount={retreatData.price}
              onSuccess={handlePaymentSuccess}
              onCancel={handlePaymentCancel}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default RetreatLanding
